import React from 'react';

interface IconProps {
    size?: number;
}

export function TallyIcon({ size = 20 }: IconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="5" y1="5" x2="5" y2="19" />
            <line x1="9" y1="5" x2="9" y2="19" />
            <line x1="13" y1="5" x2="13" y2="19" />
            <line x1="17" y1="5" x2="17" y2="19" />
            <line x1="3" y1="17" x2="19" y2="7" />
        </svg>
    );
}

export function AngleIcon({ size = 20 }: IconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Vertex at (4,20). Horizontal ray → right. Angled ray → upper right. */}
            <line x1="4" y1="20" x2="22" y2="20" />
            <line x1="4" y1="20" x2="13" y2="8" />
            {/* Arc from horizontal ray to angled ray, radius 5, centred on vertex */}
            <path d="M9 20 A5 5 0 0 0 7 16" />
        </svg>
    );
}
